/**
 * @mock wishlist
 * @swap-with StudentWishlist table + endpoints
 * @flag VITE_MOCK_WISHLIST
 * @reqs TP-06, TP-12..TP-15
 * @plan docs/impl-plans/registered-student-frontend-prototype.md (M4.2)
 *
 * localStorage-backed saved-teacher wishlist. Keyed by teacher handle. Saving a
 * teacher never notifies them (private). Instant toggle, no confirmation.
 */
import { collectionStore } from '@/mocks/localStorageStore';
import type { WishlistItem } from '@/types/registeredStudent';

const store = collectionStore<WishlistItem>('wishlist');

export function listWishlist(): WishlistItem[] {
  return store.list().sort((a, b) => b.savedAt.localeCompare(a.savedAt));
}

export function isSaved(teacherHandle: string): boolean {
  return !!store.get(teacherHandle);
}

export function toggleWishlist(teacherHandle: string, teacherName: string): boolean {
  if (store.get(teacherHandle)) {
    store.remove(teacherHandle);
    return false;
  }
  store.upsert({
    id: teacherHandle,
    teacherHandle,
    teacherName,
    savedAt: new Date().toISOString(),
  });
  return true;
}

export function removeFromWishlist(teacherHandle: string): void {
  store.remove(teacherHandle);
}
